var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSelectedStar = function SvgSelectedStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04897 0.927002C7.34897 0.00600183 8.65197 0.00600183 8.95097 0.927002L10.021 4.219C10.0863 4.41949 10.2134 4.59418 10.384 4.71811C10.5547 4.84203 10.7601 4.90885 10.971 4.909H14.433C15.402 4.909 15.804 6.149 15.021 6.719L12.221 8.753C12.05 8.87703 11.9227 9.05201 11.8573 9.25285C11.7919 9.4537 11.7918 9.67009 11.857 9.871L12.927 13.163C13.227 14.084 12.172 14.851 11.387 14.281L8.58697 12.247C8.41618 12.123 8.21053 12.0562 7.99947 12.0562C7.78842 12.0562 7.58277 12.123 7.41197 12.247L4.61197 14.281C3.82797 14.851 2.77397 14.084 3.07297 13.163L4.14297 9.871C4.20815 9.67009 4.20803 9.4537 4.14264 9.25285C4.07725 9.05201 3.94994 8.87703 3.77897 8.753L0.979974 6.72C0.196974 6.15 0.599974 4.91 1.56797 4.91H5.02897C5.24002 4.91006 5.44568 4.84334 5.6165 4.7194C5.78732 4.59546 5.91455 4.42065 5.97997 4.22L7.04997 0.928002L7.04897 0.927002Z",
    fill: "#FBBF24"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelectedStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/selected-star.39f083ef.svg";
export { ForwardRef as ReactComponent };